export default __webpack_public_path__ + "static/media/flux.d8b02f98.svg";